import {GridPhoto} from 'platform/components';

import {isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

import {useDmsLightboxActionsFactory} from '../../../hooks/useDmsLightboxActionsFactory';
import {downloadFile} from '../../../utils/downloadFile';
import {getGridPhotoFullSizeUrl} from '../../../utils/getGridPhotos';
import {Video} from '../../VideoPreview/types/video';
import {isVideoPlayable} from '../../VideoPreview/utils/isVideoPlayable';

export function useServiceCaseLightboxAssets() {
  const actionsFactory = useDmsLightboxActionsFactory();

  const makeLightboxPhotos = (photos: GridPhoto[] | Nullish) =>
    actionsFactory.addFullActions(
      photos?.map((image) => ({
        id: image.id,
        url: getGridPhotoFullSizeUrl(image),
        resizeUrl: image.resizeUrl,
        title: image.title,
        fileName: image.title || image.id ? `${image.title || image.id}.jpg` : undefined,
      }))
    );

  const makeLightboxVideos = (videos: Video[] | Nullish) =>
    actionsFactory.addShareOnlyActions(videos?.filter(isVideoPlayable), (video) => [
      {
        id: 'downloadBtn',
        icon: 'file/download',
        onClick: () => {
          if (isNotNil(video.originUrl)) {
            downloadFile(video.originUrl);
          }
        },
      },
    ]);

  return {
    makeLightboxPhotos,
    makeLightboxVideos,
    photoDownloadSizeDialog: actionsFactory.photoDownloadSizeDialog,
  };
}
